var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-message',{attrs:{"type":"is-info","size":"is-small"}},[_c('i18n',{attrs:{"path":"form.required_fields_hint"},scopedSlots:_vm._u([{key:"symbol",fn:function(){return [_c('span',{staticClass:"symbol"},[_vm._v("*")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }